import { appTitles } from "../common/services/Utilities";
import { useEffect, useState } from "react";

export function useInitialPageLoad(appName: string, noParentTitle?: boolean) {
  const [initialLoad, setInitialLoad] = useState(true);
  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
      window.scrollTo(0, 0);
      document.title = noParentTitle
        ? appTitles(appName)
        : `BankFind Suite: ${appTitles(appName)}`;
    }
  }, [initialLoad, appName, noParentTitle]);
}
